/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useEffect, useState } from "react";
import { moneyMask, moneyMaskWithoutSign, toCents } from "../../utils/Masks";
import { CarrinhoPagamentoContentStyle } from "./style";
import PagamentoCartao from "./PagamentoCartao";
import CheckoutTransparenteService from "../../services/CheckoutTransparenteService";
import ReCAPTCHA from "react-google-recaptcha";
import Switch from "../swtich/Switch";
import { useDispatch } from "react-redux";
import { ActionCreators } from "../../_actions/ActionCreators";

function CarrinhoPagamento({
  canPay,
  inserirCreditos,
  somaValorTotalFretes,
  saldo,
  onPagarCartao,
  onPagarPix,
  onProcessar,
  onProcessarCartao,
}) {
  const dispatch = useDispatch();
  const [mostrarDiferencaValor, setMostrarDiferencaValor] = useState(false);
  const [selectCarteiraFlex, setSelectCarteiraFlex] = useState(false);
  const [selectPix, setSelectPix] = useState(false);
  const [selectCreditCard, setSelectCreditCard] = useState(false);
  // const [selected, setSelected] = useState(null);
  const [splitFlexPayment, setSplitFlexPayment] = useState(false);
  const [disableFlexPayment, setDisableFlexPayment] = useState(false);
  const [disableCreditCardPayment, setDisableCreditCardPayment] = useState(false);
  const [disablePix, setDisablePix] = useState(false);
  const [token, setToken] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [cvvInput, setCvvInput] = useState("");
  const checkoutTransparenteService = new CheckoutTransparenteService();

  const handleChange = (value) => {
    if (!value) {
      console.log("Recaptcha expired or cleared");
      return;
    }

    checkoutTransparenteService.VerifyCaptcha(value, (err, data) => {
      if (err) {
        console.error("Error verifying reCAPTCHA:", err);
      } else {
        console.log("Backend verification response:", data);
        setToken(value);
      }
    });
  };

  useEffect(() => {
    if (inserirCreditos === false) {
      // Se usuário NÃO POSSUI saldo na carteira flex, deve apresentar as demais opções de pagamento.
      // A outra opção pre-selecionada deve ser o PIX.
      if (saldo === 0) {
        setSelectCarteiraFlex(false);
        setDisableFlexPayment(true);
        setMostrarDiferencaValor(true);
        setSplitFlexPayment(false);
        dispatch(ActionCreators.setSplitPayment(false));
        if (selectPix) {
          setDisableCreditCardPayment(true);
          setDisablePix(false);
          return;
        }

        if (selectCreditCard) {
          setDisableCreditCardPayment(false);
          setDisablePix(true);
        }
        return;
      }

      // Se usuário possui saldo suficiente na carteira flex, ele deve pagar apenas usando a carteira flex.
      // Comparação em centavos para evitar falha por ruído de ponto flutuante
      if (toCents(somaValorTotalFretes) <= toCents(saldo)) {
        setSelectCarteiraFlex(true);
        setMostrarDiferencaValor(false);
        setDisableFlexPayment(false);
        setDisableCreditCardPayment(true);
        setDisablePix(true);
        setSplitFlexPayment(false);
        dispatch(ActionCreators.setSplitPayment(false));
        return;
      }

      // Se usuário NÃO POSSUI saldo suficiente na carteira flex, apresentar a opção pagar com a carteira flex + outra opção.
      // A outra opção pre-selecionada deve ser o PIX.
      // Comparação em centavos para evitar falha por ruído de ponto flutuante
      if (toCents(somaValorTotalFretes) > toCents(saldo)) {
        setSelectCarteiraFlex(true);
        setDisableFlexPayment(true);
        setMostrarDiferencaValor(true);
        setSplitFlexPayment(true);
        dispatch(ActionCreators.setSplitPayment(true));
        if (selectPix) {
          setDisableCreditCardPayment(true);
          setDisablePix(false);
          return;
        }

        if (selectCreditCard) {
          setDisableCreditCardPayment(false);
          setDisablePix(true);
        }
        return;
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [somaValorTotalFretes, saldo, splitFlexPayment, selectPix, selectCreditCard, inserirCreditos]);

  const submit = (event) => {
    event.preventDefault();
    onProcessar?.();
  };

  const [isProcessing] = useState(false);
  return (
    <>
      {inserirCreditos ? (
        ""
      ) : (
        <CarrinhoPagamentoContentStyle>
          <div>
            <div className="payment-option etiqueta">
              <div className="payment-left">
                <p>
                  <strong>Valor total das etiquetas</strong>
                </p>
              </div>
              <p>{moneyMask(somaValorTotalFretes.toFixed(2).toString())}</p>
            </div>
          </div>
        </CarrinhoPagamentoContentStyle>
      )}

      <h2 className="form-title page-title" style={{ marginTop: "50px" }}>
        Escolha a opção de pagamento
      </h2>
      <CarrinhoPagamentoContentStyle>
        {/* Carteira Flex */}
        {inserirCreditos ? (
          ""
        ) : (
          <div className={`payment ${selectCarteiraFlex ? "selected" : ""}`}>
            <div className="payment-option">
              <div className="payment-left">
                <span className="payment-icon">
                  <ion-icon name="wallet-outline" style={{ fontSize: "24px" }}></ion-icon>
                </span>
                <span>
                  Carteira Flex (Saldo:{" "}
                  <strong>
                    R${" "}
                    <span className="carteira-saldo">{moneyMaskWithoutSign(saldo.toFixed(2))}</span>
                  </strong>
                  )
                </span>
              </div>
              <div className="payment-right">
                {selectCarteiraFlex && (
                  <span className="header-right">
                    {/* Comparação em centavos para evitar falha por ruído de ponto flutuante */}
                    {toCents(somaValorTotalFretes) >= toCents(saldo)
                      ? moneyMask(saldo.toFixed(2).toString())
                      : moneyMask(somaValorTotalFretes.toFixed(2).toString())}
                  </span>
                )}

                <Switch
                  checked={selectCarteiraFlex}
                  disabled={disableFlexPayment}
                  onChange={(e) => {
                    e.stopPropagation();
                    setSelectCarteiraFlex(!selectCarteiraFlex);
                  }}
                />
              </div>
            </div>

            {selectCarteiraFlex && (
              <button
                className="pix-button"
                onClick={submit}
                disabled={isProcessing || disableFlexPayment || canPay}
              >
                PAGAR AGORA
              </button>
            )}
          </div>
        )}
        {/* Carteira Pix */}

        <div className={`payment ${selectPix ? "selected" : ""}`}>
          <div className="payment-option">
            <div className="payment-left">
              <span className="payment-icon">
                {" "}
                <img src="/pix.svg" alt="Pix" style={{ width: "24px", height: "24px" }} />
              </span>
              <span>Pix</span>
            </div>
            <div className="payment-right">
              {selectPix && (
                <span className="header-right">
                  {mostrarDiferencaValor
                    ? // Subtração em centavos para evitar erro de arredondamento de ponto flutuante
                      moneyMask(
                        ((toCents(somaValorTotalFretes) - toCents(saldo)) / 100)
                          .toFixed(2)
                          .toString()
                      )
                    : moneyMask(somaValorTotalFretes.toFixed(2).toString())}
                </span>
              )}
              <input
                type="checkbox"
                className="payment-checkbox"
                checked={selectPix}
                disabled={disablePix}
                onClick={() => {
                  setSelectPix(!selectPix);
                  setDisableCreditCardPayment(false);
                  setSelectCreditCard(false);
                }}
              />
            </div>
          </div>
          {selectPix && (
            <>
              <p className="desc-payment">
                Pague usando o seu <strong>banco de preferência</strong>
              </p>
              <button
                className="pix-button"
                onClick={onPagarPix}
                disabled={isProcessing || disablePix || canPay}
              >
                PAGAR AGORA
              </button>
            </>
          )}
        </div>

        {/*  Credito */}
        <div className={`payment ${selectCreditCard ? "selected" : ""}`}>
          <div className="payment-option">
            <div className="payment-left">
              <span className="payment-icon">
                <ion-icon name="card-outline" style={{ fontSize: "24px" }}></ion-icon>
              </span>
              <span>Cartão de Crédito</span>
            </div>

            <div className="payment-right">
              {selectCreditCard && (
                <span className="header-right">
                  {mostrarDiferencaValor
                    ? // Subtração em centavos para evitar erro de arredondamento de ponto flutuante
                      moneyMask(
                        ((toCents(somaValorTotalFretes) - toCents(saldo)) / 100)
                          .toFixed(2)
                          .toString()
                      )
                    : moneyMask(somaValorTotalFretes.toFixed(2).toString())}
                </span>
              )}
              <input
                type="checkbox"
                className="payment-checkbox"
                checked={selectCreditCard}
                disabled={disableCreditCardPayment}
                onClick={() => {
                  setSelectCreditCard(!selectCreditCard);
                  setDisablePix(false);
                  setSelectPix(false);
                }}
              />
            </div>
          </div>
          {selectCreditCard && (
            <>
              {!token && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <ReCAPTCHA
                    sitekey="6LeFv8crAAAAAKERd-gr7OxUkPYEGJH5-9fSk0U6"
                    onChange={handleChange}
                  />
                </div>
              )}

              {token && (
                <>
                  {!selectedCard && (
                    <PagamentoCartao
                      isDisabled={disableCreditCardPayment}
                      somaValorTotalFretes={somaValorTotalFretes}
                      onProcessar={onProcessar}
                      onSelectCard={(card) => setSelectedCard(card)}
                      onPagarCartao={onPagarCartao}
                      onProcessarCartao={onProcessarCartao}
                      canPay={canPay}
                    />
                  )}

                  {/* Cartaozinho selecionado*/}
                  {selectedCard && (
                    <div className="credit-card-section">
                      <h2 className="desc-payment">
                        Pagando com <span className="highlight">{selectedCard.brand}</span>
                        <br />
                        <small>{selectedCard.cardNumber}</small>
                      </h2>

                      <input
                        type="text"
                        placeholder="Código de segurança"
                        className="input half"
                        value={cvvInput}
                        maxLength={3}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "").slice(0, 3);
                          setCvvInput(value);
                        }}
                        style={{ marginBottom: "12px" }}
                        required
                      />
                      <div
                        className={`use-other-card ${isProcessing ? "disabled-link" : ""}`}
                        onClick={(e) => {
                          if (isProcessing) {
                            e.preventDefault();
                            return;
                          }
                          setSelectedCard(null);
                        }}
                      >
                        Usar outro cartão
                      </div>

                      <button
                        className="pix-button"
                        onClick={(e) => {
                          e.preventDefault();
                          if (!cvvInput.trim()) {
                            alert("Por favor, insira o código de segurança");
                            return;
                          }
                          onProcessarCartao?.({
                            ...(selectedCard || {}),
                            isSavedCard: true,
                            securityCode: cvvInput,
                          });
                        }}
                        disabled={isProcessing || canPay}
                      >
                        PAGAR AGORA
                      </button>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </CarrinhoPagamentoContentStyle>
    </>
  );
}

export default CarrinhoPagamento;
